import SpeedoMeter from './speedoMeter';
export default SpeedoMeter;